'use client'

import React, { useState, useEffect, useMemo } from 'react'
import reportsData from '@/src/app/data/industryReportsHomeData.json'
import TileSwiper from '@/src/components/commons/generics/TileSwiper/TileSwiper'
import NumberedHeader from '@/src/components/commons/generics/NumberedHeader/NumberedHeader'
import { ReportTile } from './IndustryReports.interface'
import Link from 'next/link'
import styles from './IndustryReports.module.scss'

const IndustryReports: React.FC = () => {
  const [isClient, setIsClient] = useState(false) // safety check to make sure swiper is ready to init
  const txtNumber = '05'
  const txtTitle = 'Cybersecurity Industry Reports'
  const txtSeeAllReports = 'SEE ALL REPORTS'

  // Set client state
  useEffect(() => {
    setIsClient(true)
  }, [])

  // DATA TRANSFORMATION LAYER
  const mappedData: ReportTile[] = useMemo(() => {
    // Safety check: ensure data exists
    if (!reportsData || !reportsData.results) {
      return []
    }

    // Take the first 6 items from the nested 'results' array
    const rawItems = reportsData.results.slice(0, 6)

    // Map to the interface structure
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return rawItems.map((item: any) => {
      const resourceTypeLabel =
        item.resource_type?.raw?.length > 0 ? item.resource_type.raw.join(', ') : ''

      return {
        resourceType: resourceTypeLabel,
        title: item.title?.raw?.[0] || 'Untitled Report',
        ctaLink: item.link?.raw?.[0] || '#',
      }
    })
  }, [])

  return (
    <div className={`${styles.industryReports} w-full bg-white font-dm-mono p-0`}>
      <div className={`${styles.container} max-w-[1440px] my-0 mx-auto relative`}>
        <div className="mb-[30px] lg:mb-[33px] relative flex justify-between items-center">
          <NumberedHeader
            number={txtNumber}
            title={txtTitle}
            variant="gray" //red | gray
            className="mr-auto mb-0!"
          />
          {/* desktop see all */}
          {isClient && (
            <Link
              href="/industry-reports"
              className={`
                ${styles.seeAll} 
                hidden md:flex! mr-5 lg:mr-0 no-underline 
                uppercase text-[14px] font-medium tracking-[1px]
              `}
            >
              {txtSeeAllReports}
            </Link>
          )}
        </div>

        <TileSwiper variant="industryReports" data={mappedData} />

        {isClient && (
          <Link
            href="/industry-reports"
            className={`${styles.seeAll} inline-block md:hidden mr-5 no-underline uppercase text-[14px] font-medium tracking-[1px] mt-[30px]`}
          >
            {txtSeeAllReports}
          </Link>
        )}
      </div>
    </div>
  )
}

export default IndustryReports
